module.exports = __webpack_public_path__ + "Roboto-Light.37fbbbad5577a95bdf05.woff";


//////////////////
// WEBPACK FOOTER
// /app/~/roboto-fontface/fonts/Roboto/Roboto-Light.woff
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-Light.woff
// module chunks = 16